class MoonCalendarPreview extends HTMLElement {
  constructor() {
    super();

    // Retrieve data from the script tag directly
    this.metafieldsDataElement = this.querySelector('#metafields-data');

    // Parse the JSON data from the script element
    const metafieldsData = JSON.parse(this.metafieldsDataElement.textContent);

    // Store the metafields and preview data for later use
    this.previewData = metafieldsData.previewData;
    this.metafieldsData = metafieldsData;

    // Reference the preview image element
    this.previewImage = this.querySelector('#preview-image');

    window.theme = window.theme || {};
    window.theme.previewData = this.previewData;

    // Generate preview data based on metafields
    this.generatePreviewData();
    this.setPreviewImage();
    this.setItemsPosition();
    this.updateUnitSrc();
  }

  updateUnitSrc() {
    const unitImages = this.querySelectorAll('.unit-image');
    unitImages.forEach((unitImage) => {
      const unit = unitImage.dataset.unit;
      const index = unitImage.dataset.index;

      const currentSrc = unit === 'moon' ? 
      document.querySelector('.moon-phase-finder[data-index="'+index+'"] .selected-image img').src
      : document.querySelector('.birthstone-picker .selected-image img').src;

      unitImage.src = currentSrc;
    });
  }
  // Function to generate the preview data based on the metafields
  generatePreviewData() {
    const currentVariant = this.metafieldsData.currentVariant;
    const variantMetafieldInfo = this.metafieldsData.variantMetafieldInfo;
    const defaultInfo = this.metafieldsData.defaultInfo;

    let metafieldImages = null
    if (variantMetafieldInfo[currentVariant.id].variant_preview_images) {
      metafieldImages = variantMetafieldInfo[currentVariant.id].variant_preview_images
    }
    else if (defaultInfo.default_images) {
      metafieldImages = defaultInfo.default_images
    }

    // ** PREVIEW IMAGES **
    // ------------------------------------
    if (metafieldImages) {
      console.log('metafieldImages', metafieldImages)
      // if there are FOUR images then it's an ELEMENT variant
      if (metafieldImages.length === 4) {
        this.previewData.previewVersion = 'variantElement';
        const currentElement = document.querySelector('.elements-picker .selected-image img').dataset.element;
        this.previewData.previewImageDt = this.getElementImages(currentElement, metafieldImages);
      }
      // otherwise normal variant
      else {
        this.previewData.previewVersion = 'variant';
        this.previewData.previewImageDt = metafieldImages;
      }
    }
    // DEFAULT image
    else {
      console.log('default', defaultInfo.fallback_image)
      this.previewData.previewVersion = 'default';
      this.previewData.previewImageDt = defaultInfo.fallback_image;
    }

    // ** PREVIEW CSS **
    // ------------------------------------
    if (variantMetafieldInfo[currentVariant.id].variant_preview_css) {
      this.previewData.previewCSS = variantMetafieldInfo[currentVariant.id].variant_preview_css;
    }
    else {
      this.previewData.previewCSS = defaultInfo.default_css;
    }
  }

  // Helper function to retrieve element images (could be further customized)
  getElementImages(code, images) {
    let elementCode;

    if ( code ) {
      code = code.toLowerCase();
      elementCode = code.split('-')[0];
    }
    
    let index = elementCode === 'water' ? 1 : elementCode === 'air' ? 2 : elementCode === 'earth' ? 3 : 0;
    return images[index];  
  }

  setItemsPosition() {
    const { previewCSS } = this.previewData;
    if (!previewCSS) return;

    for (const key in previewCSS) {
      if (previewCSS.hasOwnProperty(key)) {
        const previewImage = document.getElementById(`preview-img-${key}`);
        if (previewImage) {
          previewImage.style.cssText = previewCSS[key];
        }
      }
    }
  }

  setPreviewImage() {
    if (!this.previewImage) return;
    const { previewImageDt } = this.previewData;
    this.previewImage.querySelector('.preview-background').src = previewImageDt;
  }
}

// Define the custom element for use in HTML
customElements.define('moon-calendar-preview', MoonCalendarPreview);